export default __webpack_public_path__ + "static/media/Space-bg 1.5f30b83f.png";